export default {
    Theme:[
        {color: '',bg:''}
    ] 
}

export const webUrl  = window.location.origin + '/'